'use strict';

/* global angular */

const MapActions = require('./MapActions');
const MapController = require('./MapController');
const MapRoutes = require('./MapRoutes');
const MapStore = require('./MapStore');
const DataExportService = require('./services/DataExportService');
const SelectOnClickDirective = require('../directives/SelectOnClickInput.js');

require('./annotationLayerEditor');
require('./measurementLayerEditor');

angular.module('dash.map', [
  'common.utils',
  'dash.siteStore',
  'dash.dataCaptureStore',
  'dash.annotationStore',
  'dash.map.AnnotationLayerEditor',
  'dash.map.MeasurementLayerEditor',
  'angular-clipboard'
])
.config(MapRoutes)
.controller('MapController', MapController)

.service('DataExportService', DataExportService)

.directive('selectOnClick', SelectOnClickDirective)

// ## Store and Actions
.factory('MapStore', MapStore)
.factory('MapActions', MapActions)

// ## Initialize
.run(['MapStore', function (MapStore) {
  MapStore.init();
}]);



// WEBPACK FOOTER //
// ./src/app/dash/map/index.js